// Image access for Welcome Day / places.
//
// Stored image paths are either a full URL (Vercel Blob uploads, from the
// editor) or a RELATIVE library path (e.g. "foodplaces/timstier/icon.png")
// that ships in public/Map Info/UofMPics/. picUrl() resolves both. Uploads go
// to Vercel Blob through /api/welcome-day (op:upload), requiring the editor token.

import { API_BASE, authHeaders } from './api.js';

// Percent-encode each path segment (the "Map Info" folder has a space — Safari's
// fetch rejects a raw space, so it must be %20).
const encodePath = (rel) => String(rel).split('/').map(encodeURIComponent).join('/');

/** Relative pic path → a servable URL. Passes through http(s)/data/blob URLs. */
export function picUrl(rel) {
  if (!rel) return '';
  if (/^(https?:|data:|blob:)/i.test(rel)) return rel;
  return '/Map%20Info/UofMPics/' + encodePath(rel);
}

/** Library listing isn't exposed in production — the editor is upload-only. */
export async function listImages() {
  return [];
}

/** Read a File as a data URL. */
function readDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

/**
 * Upload a File to Vercel Blob via the API; returns the stored URL (which
 * picUrl passes through). Requires the editor token. Only png/jpg/webp.
 */
export async function uploadImage(file, folder = '', filename = null) {
  const dataUrl = await readDataUrl(file);
  const res = await fetch(`${API_BASE}/api/welcome-day`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ op: 'upload', folder, filename: filename || file.name, dataUrl }),
  });
  if (!res.ok) throw new Error(await res.text());
  return (await res.json()).path;
}
